import React, { useState } from 'react'
import { Box, Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import InfoText from './infoText';
import BottomSheetModel from './bottomSheetModal';
import SuccessImg from '../assets/pay_success.svg'
import FailedImg from '../assets/pay_failed.svg'
import config from "../config.json";

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

const Payments = ({bookingDetails, refresh}) => {
    // const { viewAllActivities, viewRecall, setViewRecall } = useContext(GlobalStateContext)
    const theme = useTheme();
    const [loading, setLoading] = useState(false)
    const [visiblePaymentDialog, setVisiblePaymentDailog] = useState(false)
    const [paymentContent, setPaymentContent] = useState(null)


    const paymentSuccessfulHandler = () => {
        setVisiblePaymentDailog(true)
        setPaymentContent({isPaid: true, title: "Payment Successful", primaryText: "Thank you!", secondaryText: "Your payment has been received and processed successfully" })
        setLoading(false)
    }
    const paymentFailedHandler = () => {
        setVisiblePaymentDailog(true)
        setPaymentContent({isPaid: false, title: "Payment Unsuccessful", primaryText: "Uh-oh, Payment Failed", secondaryText: "Unfortunately, your payment could not be processed, Retry Payment again." })
        setLoading(false)
    }
    const closePaymentDialog = () =>{
        if(paymentContent && paymentContent.isPaid) refresh()
        setVisiblePaymentDailog(false)
    }

    const payHandler = () => {
        setLoading(true)

        fetch(`${config.HOST_NAME}/website/bookingParkings/paymentOrders`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ booking_id: bookingDetails.id }),
        })
            .then((response) => response.json())
            .then((json) => {
                if (json.success) {
                    const order = json.data.order;
                    var options = {
                        description: 'Valet Payment',
                        currency: order.currency,
                        key: config.RAZOR_PAY_KEY_ID,
                        amount: order.amount,
                        name: 'ParkSmart',
                        order_id: order.id,
                        prefill: {
                            vehicleNumber: bookingDetails.vehicle_number,
                        },
                        theme: {
                            color: "#18CC69",
                        },
                        modal: {
                            ondismiss: () => {
                                paymentFailedHandler()
                            },
                        },
                        handler: (checkoutData) => {
                            fetch(`${config.HOST_NAME}/website/bookingParkings/slotBookingPaymentVerify`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    ...checkoutData,
                                    booking_id: bookingDetails.id,
                                }),
                            })
                                .then((response) => response.json())
                                .then((json) => {
                                    if (json.success) paymentSuccessfulHandler()
                                    else paymentFailedHandler()
                                })
                                .catch((error) => {
                                    paymentFailedHandler()
                                })
                        },
                    }
                    const razorpay = new window.Razorpay(options);
                    razorpay.on('payment.failed', function ({ error }) {
                        let description, status;
                        if (isJsonString(error.description)) {
                            const errorObj = JSON.parse(error.description)
                            if (errorObj.error) {
                                description = errorObj.error.description;
                                status = errorObj.error.reason;
                            } else {
                                description = errorObj.description;
                                status = errorObj.reason;
                            }
                        } else {
                            description = error.description;
                        }
                        paymentFailedHandler()
                    })
                    razorpay.open();
                } else paymentFailedHandler()
            })
            .catch((error) => {
                console.log(error);
                paymentFailedHandler()
            })
    };


    return (
        <>
            <Box sx={theme.customStyles.valetRecallContainer}>
                <InfoText text="Please complete your payment to recall your car." />
                <Button onClick={() => payHandler()} sx={{ ...theme.customStyles.gradientButton, height: "40px", borderRadius: "4px", padding: "0", marginTop: "8px", color: "#FFFFFF" }}>
                    <Box sx={{ fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Finish Payment</Box>
                    {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </Box>
            {paymentContent &&
                <BottomSheetModel title={paymentContent.title} isOpen={visiblePaymentDialog} onClose={() => closePaymentDialog()} style={{ height: "50svh" }} >
                    <Box sx={{ marginTop: "24px", position:"absolute", top:"50%", left:"50%", transform:"translate(-50%, -50%)" }}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                           {paymentContent.isPaid ? <img src={SuccessImg} alt='Payment' width={52} height={52} /> : <img src={FailedImg} alt='Payment' width={52} height={52} />}

                            <Box sx={{ fontSize: "24px", color: "#3D3D3D", fontWeight: theme.typography.fontWeightSemibold, marginTop: "10px" }}>{paymentContent.primaryText}</Box>
                            <Box sx={{ fontSize: "16px", color: "#3D3D3D", fontWeight: theme.typography.fontWeightMedium, marginTop: "24px" }}>{paymentContent.secondaryText}</Box>
                        </Box>
                    </Box>
                </BottomSheetModel>
            }
        </>
    )
}

export default Payments